var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.5595 25.0015L32.8716 35.3133L29.9253 38.2596L16.667 25.0015L29.9253 11.7432L32.8716 14.6894L22.5595 25.0015Z",
    fill: "#BEC9C5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/Arrow_left_icon.0a78d5eb59844dd1718e03f460b7c753.svg";
export { ForwardRef as ReactComponent };